'use strict';

import VZTcBaseCard from './VZTcBaseCard';

export default class VZTcLicenses extends VZTcBaseCard {}

if (!window.customElements.get('vz-tc-licenses')) {
    window.customElements.define('vz-tc-licenses', VZTcLicenses);
}
